export default "/images/snap.svg"